import React from 'react'

import { TooltipCourse } from 'components/Editor/EditorElements/courseKit/DropDownCourse'
import DropdownMenuCourse from 'components/Editor/EditorElements/courseKit/DropdownMenuCourse/DropdownMenuCourse'
import { PLAYBACK_RATE_OPTIONS } from 'components/MediaPlayer/constants'
import Icon from 'components/uiKit/Icon'
import { KitSize } from 'components/uiKit/KitTypes'

import * as s from '../Controls.module.scss'
import { MediaControlType } from '../types'
import { useMediaT } from '../useMediaT'

interface IPlaybackRateProps {
  value: number
  onChange: (playbackRate: number) => void
  container: () => HTMLElement
  isCourse?: boolean
}

const PlaybackRateSelect: React.FC<IPlaybackRateProps> = ({
  value,
  onChange,
  container,
  isCourse = false,
}) => {
  const tt = useMediaT(isCourse)
  return (
    <TooltipCourse
      container={container()}
      overlay={tt('elements.media.playbackRate')}
      placement='top'
    >
      <div>
        <DropdownMenuCourse
          ariaLabel={`Playback rate ${value}`}
          buttonProps={{ 'data-player-control': MediaControlType.PlaybackRate }}
          container={container()}
          onClick={(option) => onChange(option.value)}
          options={PLAYBACK_RATE_OPTIONS}
          value={value}
        >
          <div className={s.buttons}>
            <Icon name='playLoading' size={KitSize.S} aria-hidden />
          </div>
        </DropdownMenuCourse>
      </div>
    </TooltipCourse>
  )
}

export default PlaybackRateSelect
